<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="23" y="10.75" width="2.5" height="22" rx="1.25" transform="rotate(90 23 10.75)" fill="current"/>
</svg>
